import graphql__566eaf0c7d86ad0a6601 from "./__generated__/AnswerPreviewEmailWithConsents_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

const AnswerPreviewEmailWithConsents = props => {
  return props.answer.content || "-";
};

export default createFragmentContainer(AnswerPreviewEmailWithConsents, {
  answer: graphql__566eaf0c7d86ad0a6601
});
